export const ROUTES = {
	PLAN: process.env.PUBLIC_URL + '/plan',
	LOADER: process.env.PUBLIC_URL + '/plan/loader',
	HOME: process.env.PUBLIC_URL + '/plan/home',
	CONTACTS: process.env.PUBLIC_URL + '/plan/contacts',
	SURVEY: process.env.PUBLIC_URL + '/plan/survey',
	RESULT: process.env.PUBLIC_URL + '/plan/result',

	PAY: process.env.PUBLIC_URL + '/pay',
	PAYWALL: process.env.PUBLIC_URL + '/pay/paywall',
	PAYMENT: process.env.PUBLIC_URL + '/pay/payment',
	ACTIVATION_INSTRUCTIONS: process.env.PUBLIC_URL + '/pay/activationInstructions',
};

export const isUAEntryPointRoute = (pathname: string): boolean => {
	const entryPointRoutes = [ROUTES.PAY, ROUTES.PAY + '/', ROUTES.PLAN, ROUTES.PLAN + '/'];
	return entryPointRoutes.some(route => pathname.includes(route));
};

export const isPayRoute = (path: string): boolean => {
	return path.includes(ROUTES.PAY);
};

export const isPlanRoute = (path: string): boolean => {
	return path.includes(ROUTES.PLAN);
};
